




















































import { Component, Watch, Prop } from 'vue-property-decorator';
import DictAPI from '@/services/rest/bemob/dictionary';
import { debounce, differenceBy, uniq } from 'lodash';
import LoadingCircle from '@/components/loading-circle.vue';
import { mixins } from 'vue-class-component';
import MobileHelperMixin from '@/components/helpers/mobile-helper-mixin';

@Component({
  components: {
    LoadingCircle
  }
})
export default class Dictionary extends mixins(MobileHelperMixin) {
  @Prop()
  conditions: any;

  @Prop() 
  target: any;

  @Prop() 
  api: any;

  @Prop() 
  title: string;

  @Prop({ default: false })
  withCustomArea: boolean;

  @Prop() 
  searchPlaceholder: string;

  @Prop() 
  name: string;

  @Prop({ default: true }) 
  allowCustom: boolean;

  search: string = '';
  predicate: string = 'EQUALS';

  items: any[] = [];
  loading: boolean = false;
  includeUnknown: boolean = false;
  dictApi: any = new DictAPI();
  selected: any[] = [];
  
  @Watch('selected')
  selectedChanged() {
    this.setCondition();
  }
  
  get isNameCountry(){
    return this.name==='country'
  }

  mounted() {
    if (this.conditions[this.name]) {
      this.includeUnknown = this.conditions[this.name].includeUnknown;
      this.predicate = this.conditions[this.name].predicate || 'EQUALS';
    } else {
      this.$set(this.conditions, this.name, {
        predicate: this.predicate,
        includeUnknown: this.includeUnknown,
        values: this.selected
      });
    }

    this.loading = true;
    this.load(false).then((items) => {
      let values = this.conditions[this.name].values || [];

      if(this.isNameCountry){
        values = values.map((code:string)=>items.find((item:{code:string})=>item.code === code));
      }

      this.selected = values;
      this.items = uniq([...items, ...this.selected]);

      this.loading = false;
    });
  } 

  @Watch('predicate')
  onPredicateChanged(value: string) {
    this.$set(this.conditions[this.name], 'predicate', value);
  }

  @Watch('blur:textarea')
  async onBlur(event, { value }) {
    this.bus.emit('loading-add-dictionary', true);
    
    this.dictApi.validate(this.api, value).then(response => {
      if (response.length !== value.length) {
        this.bus.emit('toast-warning', this.t(`Some of the elements can't be added due to the misspelling. Please check the correct values using 'From the list' settings of this rule.`));
      }

      this.items = uniq([...this.items, ...response]);
      if(this.isNameCountry){
        this.selected = response;
      }else {
        this.selected = response.map((item:{name:string})=>item.name);
      }

      this.setCondition();
      
      this.bus.emit('loading-add-dictionary', false);

      const { relatedTarget } = event

      if (relatedTarget && relatedTarget.type === 'button' && relatedTarget.dataset.action === 'save') {
        setTimeout(() => relatedTarget.click())
      }
    }).finally(() => this.bus.emit('loading-add-dictionary', false))

  }

  @Watch('includeUnknown')
  onIncludeUnknownChanged(value: string) {
    this.$set(this.conditions[this.name], 'includeUnknown', value);
  }
  
  setCondition(){
    let value = this.selected;
    const key = this.name === 'country' ? 'code' : 'name';
    
    if(this.isNameCountry){
      value = value.map((item: { 'name':string, 'code':string })=>item[key])
    }
    
    if(!this.conditions[this.name]) {
      this.$set(this.conditions, this.name, {
        predicate:  'EQUALS',
      });
    }

    this.$set(this.conditions[this.name], 'values', value);
  }
  
  loadRequest(){
    if(this.isNameCountry) {
      return Promise.resolve(this.$store.state.countryList)
    }

    return this.dictApi.get(this.api, { limit: 100, name: this.search })
  }

  load(updateItems = true) {
    return this.loadRequest()
    .then((items)=>{
      if(updateItems){
        this.items = uniq([...items, ...this.items]);
      }
      return items;
    })
  }

  get debouncedSearch() {
    return debounce(this.load, 500);
  }

  @Watch('search')
  searchChanged() {
    this.debouncedSearch();
  }
}
